import * as React from 'react';
import { useParams } from 'react-router-dom';
import { IncidentType } from '../../../../amorg-common';
import { SingleColumnLayout } from '../../../_layouts/SingleColumnLayout';
import { EmployeePageWrapper } from '../../../_pageWrappers/EmployeePageWrapper';
import { IncidentAlmostAccident } from '../_components/IncidentAlmostAccident';
import { IncidentIssue } from '../_components/IncidentIssue';
import { IncidentWhistleblower } from '../_components/IncidentWhistleblower';
import { IncidentWorkInjury } from '../_components/IncidentWorkInjury';

export function PortalIncidentPage(): JSX.Element
{
    return (
        <EmployeePageWrapper>
            <PortalIncidentPageContent />
        </EmployeePageWrapper>
    );
}

function PortalIncidentPageContent():JSX.Element
{

    const [incidentType, setIncidentType] = React.useState<IncidentType | null>(null);

    const params = useParams<{ type?: string }>();
    React.useEffect(() => {
        const typeParam = params.type;
        if (typeParam) {
            setIncidentType(typeParam as IncidentType);
        }
    }, [params.type]);

    return (
        <SingleColumnLayout narrow>
            <>
                {incidentType !== null && incidentType === "issue" &&                         
                    <IncidentIssue />
                }

                {incidentType !== null && incidentType === "almost-accident" && 
                    <IncidentAlmostAccident />
                }

                {incidentType !== null && incidentType === "work-injury" && 
                    <IncidentWorkInjury />
                }

                {incidentType !== null && incidentType === "whistleblower" && 
                    <IncidentWhistleblower />
                }
            </>
        </SingleColumnLayout>
    );
}





